import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Filler,
} from "chart.js";

// Отключаем все встроенные плагины для отображения текста
const textPlugins = ["centerText", "text", "datalabels", "labels"];
textPlugins.forEach((pluginId) => {
  if (ChartJS.registry.plugins.get(pluginId)) {
    ChartJS.unregister(ChartJS.registry.plugins.get(pluginId));
  }
});

// Регистрируем только необходимые компоненты
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Filler
);

// Глобальные настройки
ChartJS.defaults.set("font", {
  family: "Manrope",
});

ChartJS.defaults.set("color", "#666");

ChartJS.defaults.set("plugins", {
  legend: {
    position: "bottom",
  },
  title: {
    display: false,
  },
  subtitle: {
    display: false,
  },
  // Отключаем все текстовые плагины
  datalabels: false,
  labels: false,
});
